import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const GemsListPage = lazy(() =>
  import('./pages/gems-list-page').then((m) => ({ default: m.GemsListPage })),
);
const GemDetailPage = lazy(() =>
  import('./pages/gem-detail-page').then((m) => ({ default: m.GemDetailPage })),
);
const GemConversationPage = lazy(() =>
  import('./pages/gem-conversation-page').then((m) => ({ default: m.GemConversationPage })),
);

// `/gems` and `/gems/:slug` are public — discoverable like the landing page.
export const gemsPublicRoutes: RouteObject[] = [
  {
    path: 'gems',
    element: (
      <Suspense fallback={null}>
        <GemsListPage />
      </Suspense>
    ),
  },
  {
    path: 'gems/:slug',
    element: (
      <Suspense fallback={null}>
        <GemDetailPage />
      </Suspense>
    ),
  },
];

// `/gems/:slug/c/:conversationId` is auth-required — wraps the gem chat surface.
export const gemsProtectedRoutes: RouteObject[] = [
  {
    path: 'gems/:slug/c/:conversationId',
    element: (
      <Suspense fallback={null}>
        <GemConversationPage />
      </Suspense>
    ),
  },
];
